import {Injectable} from '@angular/core';
import {GameService} from './game.service';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {Observable} from 'rxjs';
import {Catcher} from '../models/catcher';
import firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root'
})
export class CatcherService {

  // Never subscribe in service - either use async pipe in template, or subscribe directly in component code, saving result to local object
  // Normally will use 'first()' for forms, so it doesn't change as user is typing, then send that object
  //    back to service to be updated (don't just rely on service to hold current state)
  teams$: Observable<Catcher[]>;

  constructor(private gameService: GameService, private afs: AngularFirestore) {
    this.loadCatcherObservable();
  }

  loadCatcherObservable(): void {
    this.teams$ = this.afs.collection<Catcher>(`games/${this.gameService.currentGame.id}/catchingTeams`)
      .valueChanges();
  }

  create(catcher: Catcher): void {
    // Set catcher as current user
    catcher.contactEmail = catcher.id;
    this.afs.doc(`games/${this.gameService.currentGame.id}/catchingTeams/${catcher.id}`).set({...catcher}).then(() => {
      console.log(catcher);
    });
    // Set user as catcher
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${catcher.id}`);
    const data = {
      'roles.catcher': firebase.firestore.FieldValue.arrayUnion(this.gameService.currentGame.id)
    };
    userRef.update(data).then(() => {
      this.loadCatcherObservable();
    });
  }


}
